import { render, staticRenderFns } from "./video_item.vue?vue&type=template&id=4b173aa2&scoped=true&"
import script from "./video_item.vue?vue&type=script&lang=js&"
export * from "./video_item.vue?vue&type=script&lang=js&"
import style0 from "./video_item.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./video_item.vue?vue&type=style&index=1&id=4b173aa2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b173aa2",
  null
  
)

export default component.exports